import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import type { Position, Snackbar, SnackbarTypes } from './snackbar.service';
import { SNACKBAR_DATA, SnackbarService } from './snackbar.service';

@Component({
  selector: 'ui-snackbar',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent {
  snackbarService = inject(SnackbarService);
  dataRaw = inject(SNACKBAR_DATA);
  data = signal<Snackbar[]>(this.dataRaw);

  backgroundColor: { [key in SnackbarTypes]: string } = {
    info: 'bg-cp-primary-100',
    warning: 'bg-cp-highlight-mid-100',
    error: 'bg-cp-error-100',
    success: 'bg-cp-secondary-100',
  } as const;

  trackById(index: number, item: Snackbar) {
    return item.id;
  }

  trackByPosition(_: number, item: { position: Position; items: Array<Snackbar> }) {
    return item.position;
  }

  updateData(data: Array<Snackbar>) {
    this.data.set(data);
  }
}
